<template>
	<a
		:href="link"
		:target="target"
		@click="$emit('click')"
	>
		<slot />
	</a>
</template>

<script>
export default {
	props: {
		link: {
			type: String,
			required: true,
		},

		target: {
			type: String,
			required: false,
			default: '_self',
		},
	},
};
</script>
